import React, { useMemo } from 'react'
import { Form } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import I18n from 'resources/i18n/I18n'
import SectorItem from './SectorItem'

import {
  areAllAgenciesSelected,
  calculateAgencyCount,
  checkIfDisabled,
  getFilteredSectors,
  getSelectedAgencyIds,
} from '../../../../utils/patrimonyUtils'

const PatrimonyItem = ({
  patrimony,
  level = 0,
  type,
  userAgencies,
  expandedItems,
  selectedItems,
  onToggleExpand,
  onSelectionChange,
  associatedAgencies = [],
}) => {
  const isDisabled = useMemo(() => checkIfDisabled(type, patrimony.sectors, associatedAgencies), [type, patrimony.sectors, associatedAgencies])

  const filteredSectors = useMemo(
    () => getFilteredSectors(patrimony.sectors, type, associatedAgencies, selectedItems),
    [patrimony.sectors, type, associatedAgencies, selectedItems],
  )

  const isExpanded = useMemo(() => expandedItems.includes(patrimony.id), [expandedItems, patrimony.id])

  const agencyCount = useMemo(
    () => calculateAgencyCount(filteredSectors, type, associatedAgencies, selectedItems),
    [filteredSectors, type, associatedAgencies, selectedItems],
  )

  const isAllSelected = areAllAgenciesSelected(filteredSectors, selectedItems)

  const handleSelect = () => {
    const newSelectedItems = getSelectedAgencyIds(filteredSectors, type, associatedAgencies, isAllSelected, selectedItems)

    onSelectionChange(newSelectedItems)
  }

  const patrimonyLabel = I18n.t('patrimony.agencyCount', {
    label: patrimony.label,
    count: agencyCount,
  })

  if (filteredSectors.length === 0) {
    return null
  }

  return (
    <div className={`patrimony-item agency-menu-item agency-menu-level-${level} ${isDisabled ? 'disabled-item' : ''}`}>
      <div className="d-flex justify-content-between p-3 bg-white rounded shadow-sm">
        {!isDisabled && (
          <Form.Check
            type="checkbox"
            checked={isAllSelected}
            onChange={handleSelect}
            label={patrimonyLabel}
            id={`patrimony-${type}-${patrimony.code}`}
            key={`patrimony-${type}-${patrimony.code}`}
          />
        )}
        {isDisabled && <span>{patrimonyLabel}</span>}
        <FontAwesome className="rct-icon" name={isExpanded ? 'chevron-down' : 'chevron-right'} onClick={() => onToggleExpand(patrimony.id)} />
      </div>
      {isExpanded && (
        <div className="mt-2">
          {filteredSectors.map((sector) => (
            <SectorItem
              key={sector.id}
              sector={sector}
              level={level + 1}
              type={type}
              userAgencies={userAgencies}
              expandedItems={expandedItems}
              selectedItems={selectedItems}
              onToggleExpand={onToggleExpand}
              onSelectionChange={onSelectionChange}
              associatedAgencies={associatedAgencies}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default React.memo(PatrimonyItem)
